import Admins from "@/views/Admins.vue";
import Billing from "@/views/Billing.vue";
import Certifications from "@/views/Certifications.vue";
import Dashboard from "@/views/Dashboard.vue";
import OrderDetail from "@/views/OrderDetail.vue";
import Profile from "@/views/Profile.vue";
import Revenue from "@/views/Revenue.vue";
import Rtl from "@/views/Rtl.vue";
import Settings from "@/views/Settings.vue";
import SignIn from "@/views/SignIn.vue";
import SignUp from "@/views/SignUp.vue";
import Tables from "@/views/Tables.vue";
import Users from "@/views/Users.vue";
import VirtualReality from "@/views/VirtualReality.vue";
import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/dashboard",
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: { title: "儀表板" },
  },
  {
    path: "/product-policy",
    name: "ProductPolicy",
    component: () => import("../views/ProductPolicy.vue"),
  },
  {
    path: "/products",
    name: "Products",
    component: () => import("@/views/Products.vue"),
    meta: { title: "商品列表" },
  },
  {
    path: "/products/new",
    name: "ProductCreate",
    component: () => import("@/views/ProductForm.vue"),
    meta: { title: "新增商品" },
  },
  {
    path: "/products/:id",
    name: "ProductDetail",
    component: () => import("@/views/ProductDetail.vue"),
    meta: { title: "商品詳情" },
  },
  {
    path: "/products/:id/edit",
    name: "ProductEdit",
    component: () => import("@/views/ProductForm.vue"),
    meta: { title: "編輯商品" },
  },
  {
    path: "/products/:id/inventory",
    name: "ProductInventory",
    component: () => import("@/views/ProductInventory.vue"),
  },
  {
    path: "/warehouses",
    name: "Warehouses",
    component: () => import("@/views/Warehouses.vue"),
    meta: { title: "倉庫管理" },
  },
  {
    path: "/warehouses/:id",
    name: "WarehouseDetail",
    component: () => import("@/views/WarehouseDetail.vue"),
    meta: { title: "倉庫詳情" },
  },
  {
    path: "/categories",
    name: "Categories",
    component: () => import("@/views/Categories.vue"),
  },
  {
    path: "/tags",
    name: "Tags",
    component: () => import("@/views/Tags.vue"),
  },
  {
    path: "/orders",
    name: "Orders",
    component: () => import("@/views/Orders.vue"),
    meta: { title: "訂單列表" },
  },
  {
    path: "/chat",
    name: "ChatLobby",
    component: () => import("@/views/ChatLobby.vue"),
  },
  {
    path: "/orders/:id",
    name: "OrderDetail",
    component: OrderDetail,
    meta: { title: "訂單詳情" },
  },
  {
    path: "/certifications",
    name: "Certifications",
    component: Certifications,
  },
  {
    path: "/users",
    name: "Users",
    component: Users,
    meta: { title: "會員列表" },
  },
  {
    path: "/admins",
    name: "Admins",
    component: Admins,
  },
  {
    path: "/revenue",
    name: "Revenue",
    component: Revenue,
  },
  {
    path: "/settings",
    name: "Settings",
    component: Settings,
    meta: { title: "平台設定" },
  },
  {
    path: "/language-settings",
    name: "LanguageSettings",
    component: () => import("@/views/LanguageSettings.vue"),
    meta: { title: "語系設定" },
  },
  {
    path: "/languages/:languageId/translations",
    name: "Translations",
    component: () => import("@/views/Translations.vue"),
    meta: { title: "翻譯管理" },
  },
  {
    path: "/blog",
    name: "Blog",
    component: () => import("@/views/Blog.vue"),
  },
  {
    path: "/blog/categories",
    name: "BlogCategories",
    component: () => import("@/views/BlogCategories.vue"),
  },
  {
    path: "/payment-settings",
    name: "PaymentSettings",
    component: () => import("@/views/PaymentSettings.vue"),
    meta: { title: "金流設定" },
  },
  {
    path: "/blog/new",
    name: "BlogCreate",
    component: () => import("@/views/BlogForm.vue"),
  },
  {
    path: "/blog/:id/edit",
    name: "BlogEdit",
    component: () => import("@/views/BlogForm.vue"),
  },
  {
    path: "/inventory-scanner",
    name: "InventoryScanner",
    component: () => import("@/views/InventoryScanner.vue"),
  },
  {
    path: "/brands",
    name: "Brands",
    component: () => import("@/views/Brands.vue"),
    meta: { title: "品牌管理" },
  },
  {
    path: "/brands/new",
    name: "BrandCreate",
    component: () => import("@/views/BrandForm.vue"),
  },
  {
    path: "/brands/:id/edit",
    name: "BrandEdit",
    component: () => import("@/views/BrandForm.vue"),
  },
  {
    path: "/banners",
    name: "Banners",
    component: () => import("@/views/HeroBanners.vue"),
    meta: { title: "廣告橫幅" },
  },
  {
    path: "/homepage-sections",
    name: "HomepageManager",
    component: () => import("@/views/HomepageManager.vue"),
    meta: { title: "首頁管理" },
  },
  {
    path: "/homepage-sections/new",
    name: "HomepageSectionCreate",
    component: () => import("@/views/HomepageSectionForm.vue"),
  },
  {
    path: "/homepage-sections/:id/edit",
    name: "HomepageSectionEdit",
    component: () => import("@/views/HomepageSectionForm.vue"),
  },
  {
    path: "/banners/new",
    name: "BannerCreate",
    component: () => import("@/views/HeroBannerForm.vue"),
  },
  {
    path: "/banners/:id/edit",
    name: "BannerEdit",
    component: () => import("@/views/HeroBannerForm.vue"),
  },
  {
    path: "/menu-management",
    name: "MenuManagement",
    component: () => import("@/views/MenuManagement.vue"),
    meta: { title: "選單管理" },
  },
  {
    path: "/staff",
    name: "StaffManagement",
    component: () => import("../views/StaffManagement.vue"),
    meta: { title: "員工管理" },
  },
  {
    path: "/permissions",
    name: "PermissionSettings",
    component: () => import("../views/PermissionSettings.vue"),
    meta: { title: "權限設定" },
  },
  {
    path: "/roles",
    name: "RoleManagement",
    component: () => import("@/views/RoleManagement.vue"),
    meta: { title: "角色管理" },
  },
  {
    path: "/tables",
    name: "Tables",
    component: Tables,
  },
  {
    path: "/billing",
    name: "Billing",
    component: Billing,
  },
  {
    path: "/virtual-reality",
    name: "Virtual Reality",
    component: VirtualReality,
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
  },
  {
    path: "/rtl-page",
    name: "Rtl",
    component: Rtl,
  },
  {
    path: "/sign-in",
    name: "Sign In",
    component: SignIn,
  },
  {
    path: "/sign-up",
    name: "Sign Up",
    component: SignUp,
  },
  {
    path: "/newsletter",
    name: "Newsletter",
    component: () => import("@/views/Newsletter.vue"),
  },
  {
    path: "/marketing/coupons",
    name: "Coupons",
    component: () => import("@/views/marketing/Coupons.vue"),
    meta: { title: "折價券管理" },
  },
  {
    path: "/marketing/coupons/new",
    name: "CouponCreate",
    component: () => import("@/views/marketing/CouponForm.vue"),
    meta: { title: "新增折價券" },
  },
  {
    path: "/marketing/coupons/:id/edit",
    name: "CouponEdit",
    component: () => import("@/views/marketing/CouponForm.vue"),
    meta: { title: "編輯折價券" },
  },
  {
    path: "/marketing/coupons/:id",
    name: "CouponDetail",
    component: () => import("@/views/marketing/CouponDetail.vue"),
    meta: { title: "折價券詳情" },
  },
  {
    path: "/marketing/promotions",
    name: "Promotions",
    component: () => import("@/views/marketing/Promotions.vue"),
    meta: { title: "全站折扣管理" },
  },
  {
    path: "/marketing/promotions/new",
    name: "PromotionCreate",
    component: () => import("@/views/marketing/PromotionForm.vue"),
    meta: { title: "新增折扣活動" },
  },
  {
    path: "/marketing/promotions/:id/edit",
    name: "PromotionEdit",
    component: () => import("@/views/marketing/PromotionForm.vue"),
    meta: { title: "編輯折扣活動" },
  },
  {
    path: "/faqs",
    name: "Faqs",
    component: () => import("@/views/Faqs.vue"),
    meta: { title: "常見問題" },
  },
  {
    path: "/faqs/new",
    name: "FaqCreate",
    component: () => import("@/views/FaqForm.vue"),
  },
  {
    path: "/faqs/:id/edit",
    name: "FaqEdit",
    component: () => import("@/views/FaqForm.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

// Route guard for authentication and authorization
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");
  const userStr = localStorage.getItem("user");
  const user = userStr ? JSON.parse(userStr) : null;

  // Public routes
  const publicPages = ["/sign-in", "/sign-up"];
  const authRequired = !publicPages.includes(to.path);

  // Check if authentication is required
  if (authRequired && !token) {
    return next("/sign-in");
  }

  // Redirect to dashboard if already logged in and trying to access public pages
  if (token && publicPages.includes(to.path)) {
    return next("/dashboard");
  }

  // Check role-based access for restricted pages
  // We now use permissions instead of hardcoded roles

  // Mapping of routes to required permissions
  const routePermissions = {
    // System
    "/dashboard": "dashboard.view",
    "/settings": "system.settings",
    "/payment-settings": "system.payment",
    "/menu-management": "system.menu",
    "/language-settings": "system.settings",
    "/users": "users.view",
    "/admins": "staff.manage",
    "/roles": "system.roles_manage",
    "/permissions": "system.permissions_view",
    "/staff": "staff.manage",
    "/tables": "dashboard.view",
    "/billing": "system.settings",
    "/virtual-reality": "dashboard.view",
    "/rtl-page": "dashboard.view",
    "/profile": null,

    // Products
    "/products": "products.view",
    "/product-policy": "products.edit",
    "/products/new": "products.create",
    "/brands": "brands.manage",
    "/categories": "categories.manage",
    "/tags": "tags.manage",
    "/inventory-scanner": "product.inventory",

    // Warehouses
    "/warehouses": "warehouses.manage",

    // Orders
    "/orders": "orders.view",
    "/chat": "chat.manage",
    "/certifications": "orders.certifications",

    // Marketing
    "/banners": "marketing.banners",
    "/blog": "marketing.blog_posts",
    "/blog/categories": "marketing.blog_categories",
    "/homepage-sections": "marketing.homepage",
    "/newsletter": "marketing.newsletter",
    "/marketing/coupons": "marketing.coupons",
    "/marketing/promotions": "marketing.promotions",

    "/revenue": "dashboard.revenue",
    "/faqs": "marketing.homepage",
  };

  // Check specific route permissions
  // 1. Direct match
  let requiredPermission = routePermissions[to.path];

  // 2. Prefix match for sub-routes (e.g. /products/...)
  if (!requiredPermission) {
    if (to.path.startsWith("/products/")) {
      // Detail view is view, edit/new is edit
      if (to.path.includes("/edit") || to.path === "/products/new") {
        requiredPermission = "products.edit";
        if (to.path === "/products/new") requiredPermission = "products.create";
        if (to.path.includes("/inventory"))
          requiredPermission = "product.inventory";
      } else {
        requiredPermission = "products.view";
      }
    } else if (to.path.startsWith("/orders/")) {
      requiredPermission = "orders.view";
      // Note: Specific edit/delete actions usually handled in-component,
      // but viewing detail requires view permission.
    } else if (to.path.startsWith("/banners/")) {
      requiredPermission = "marketing.banners";
    } else if (to.path.startsWith("/brands/")) {
      requiredPermission = "brands.manage";
    } else if (to.path.startsWith("/blog")) {
      requiredPermission = "marketing.blog_posts";
    } else if (to.path.startsWith("/homepage-sections")) {
      requiredPermission = "marketing.homepage";
    } else if (to.path.startsWith("/marketing/promotions")) {
      requiredPermission = "marketing.promotions";
    } else if (to.path.startsWith("/marketing/coupons")) {
      requiredPermission = "marketing.coupons"; // Assuming coupons use this or fallback
    } else if (to.path.startsWith("/languages/")) {
      requiredPermission = "system.settings";
    } else if (to.path.startsWith("/warehouses")) {
      requiredPermission = "warehouses.manage";
    }
  }

  if (requiredPermission) {
    // Helper function to check if user has permission
    // We need to re-implement hasPermission here or import it if possible.
    // Importing might be tricky with circular deps but utils usually fine.
    // Let's rely on the user object in localstorage.

    const hasPerm = (p) => {
      if (!user) return false;
      // Robust Super Admin Check
      if (user.role === "super_admin") return true;
      if (user.role && user.role.slug === "super_admin") return true;
      if (user.user_role && user.user_role.slug === "super_admin") return true;
      if (user.userRole && user.userRole.slug === "super_admin") return true;

      if (user.permissions && Array.isArray(user.permissions)) {
        if (user.permissions.includes(p)) return true;
        const parts = p.split(".");
        if (parts.length > 1 && user.permissions.includes(parts[0] + ".*"))
          return true;
      }
      return false;
    };

    if (!hasPerm(requiredPermission)) {
      // Allow revenue only for super_admin if no specific permission exists yet
      if (to.path === "/revenue" && !hasPerm("dashboard.view")) {
        // revenue might be special, let's keep it strict
      }

      alert("您沒有權限訪問此頁面");
      return next("/dashboard");
    }
  }

  next();
});

export default router;
